import SchoolIcon from "@mui/icons-material/School";
import React from "react";

export const education_text =
  "During my time at university, I was able to approach many aspects of computer science and better understand how much this science is present in everything around us.\n I was fascinated by how vast and mutable this world is, sparking in me a great passion for this field. Thanks to my undergraduate studies, I possess an excellent Computer Science background that I wish to enrich over time.";

export const educations = [
  {
    icon: <SchoolIcon sx={{ fontSize: 50 }} />,
    title: "Bachelor's Degree ",
    image: "/images/bachelor.jpeg",
    link: "https://www.unimi.it/en/education/computer-science",
    description: "L-31 ~ Computer science",
    years: "Sept. 2016 - Feb. 2021",
    exams: [
      {
        id: 0,
        title: "Computer Architecture I",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/computer-architecture-i",
        teacher: "Borghese Nunzio Alberto",
        teacherLink: "https://www.unimi.it/en/ugov/person/alberto-borghese",
      },
      {
        id: 1,
        title: "Computer Programming",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/computer-programming-0",
        teacher: "Boldi Paolo",
        teacherLink: "https://www.unimi.it/en/ugov/person/paolo-boldi",
      },
      {
        id: 3,
        title: "Continuum Mathematics",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/continuum-mathematics-0",
        teacher: "Gori Anna",
        teacherLink: "http://www.mat.unimi.it/users/gori/Sito/Home.html",
      },
      {
        id: 4,
        title: "Automata and Formal Languages",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/automata-and-formal-languages",
        teacher: "Palano Beatrice Santa",
        teacherLink: "https://www.unimi.it/en/ugov/person/beatrice-palano",
      },
      {
        id: 5,
        title: "Computer Architecture II",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/computer-architecture-ii",
        teacher: "Borghese Nunzio Alberto",
        teacherLink: "https://www.unimi.it/en/ugov/person/alberto-borghese",
      },
      {
        id: 6,
        title: "Discrete Mathematics",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/discrete-mathematics-0",
        teacher: "Turrini Cristina",
        teacherLink: "https://www.unimi.it/it/ugov/person/cristina-turrini",
      },
      {
        id: 7,
        title: "Mathematical Logic",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/mathematical-logic",
        teacher: "Aguzzoli Stefano",
        teacherLink: "https://www.unimi.it/en/ugov/person/stefano-aguzzoli",
      },
      {
        id: 8,
        title: "Algorithms and Data Structures",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/algorithms-and-data-structures-0",
        teacher: "Pighizzini Giovanni",
        teacherLink: "https://www.unimi.it/en/ugov/person/giovanni-pighizzini",
      },
      {
        id: 9,
        title: "Operating Systems",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/operating-systems",
        teacher: "Bruschi Danilo Mauro",
        teacherLink: "https://www.unimi.it/en/ugov/person/danilo-bruschi",
      },
      {
        id: 10,
        title: "Databases",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/databases-0",
        teacher: "Ferrara Alfio",
        teacherLink: "https://www.unimi.it/it/ugov/person/alfio-ferrara",
      },
      {
        id: 11,
        title: "Statistics and Data Analysis",
        link: "https://www.unimi.it/en/education/computer-science",
        teacher: "Malchiodi Dario",
        teacherLink: "https://www.unimi.it/it/ugov/person/dario-malchiodi",
      },
      {
        id: 12,
        title: "Computer Networks",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/computer-networks-0",
        teacher: "Rossi Gian Paolo",
        teacherLink: "https://www.unimi.it/en/ugov/person/gianpaolo-rossi",
      },
      {
        id: 13,
        title: "Software Engineering",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/software-engineering",
        teacher: "Bellettini Carlo Nicola Maria",
        teacherLink: "https://www.unimi.it/en/ugov/person/carlo-bellettini",
      },
      {
        id: 14,
        title: "Cryptography I",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2022/cryptography-i",
        teacher: "Visconti Andrea",
        teacherLink: "https://www.unimi.it/en/ugov/person/andrea-visconti",
      },
      {
        id: 15,
        title: "Information Systems",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2022/information-systems",
        teacher: "Castano Silvana",
        teacherLink: "https://www.unimi.it/en/ugov/person/silvana-castano",
      },
      {
        id: 16,
        title: "Security and Privacy",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2021/security",
        teacher: "Andrea Lanzi",
        teacherLink: "https://www.unimi.it/en/ugov/person/andrea-lanzi",
      },
      {
        id: 17,
        title: "information and transmission theory",
        link: "https://homes.di.unimi.it/~cesabian/tinfo/",
        teacher: "Visconti Andrea",
        teacherLink: "https://www.unimi.it/en/ugov/person/andrea-visconti",
      },
      {
        id: 18,
        title: "digital products law",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2022/information-technology-law",
        teacher: "Jori Matteo Giacomo",
        teacherLink: "https://www.unimi.it/it/ugov/person/matteo-jori",
      },
      {
        id: 19,
        title: "digital marketing",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2022/digital-marketing",
        teacher: "Tedeschi Toschi Alessandra",
        teacherLink:
          "https://www.linkedin.com/in/alessandra-tedeschi-toschi-2912078/?originalSubdomain=it",
      },
    ],
  },
  {
    icon: <SchoolIcon sx={{ fontSize: 50 }} />,
    title: "Master's Degree ",
    image: "/images/master.jpeg",
    link: "https://www.unimi.it/en/education/computer-science-master",
    description: "LM-18 ~ Computer science",
    years: "Sept. 2021 - July 2023",
    exams: [
      {
        id: 1,
        title: "Affective Computing",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/affective-computing",
        teacher: "Boccignone Giuseppe",
        teacherLink: "https://www.unimi.it/en/ugov/person/giuseppe-boccignone",
      },
      {
        id: 2,
        title: "Artificial Intelligence",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/artificial-intelligence-0",
        teacher: "Piuri Vincenzo",
        teacherLink: "https://www.unimi.it/en/ugov/person/vincenzo-piuri",
      },
      {
        id: 3,
        title: "Business Information Systems",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/business-information-sistems",
        teacher: "Ceravolo Paolo",
        teacherLink: "https://www.unimi.it/en/ugov/person/paolo-ceravolo",
      },
      {
        id: 4,
        title: "Business Process Engineering",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/business-process-engineering",
        teacher: "Gianini Gabriele",
        teacherLink: "https://www.unimi.it/en/ugov/person/gabriele-gianini",
      },
      {
        id: 5,
        title: "Intelligent Systems for Industry, Supply Chain and Environment",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/intelligent-systems-industry-supply-chain-and-environment",
        teacher: "Scotti Fabio",
        teacherLink: "https://www.unimi.it/en/ugov/person/fabio-scotti",
      },
      {
        id: 6,
        title: "Multimedia Architectures",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/multimedia-architectures",
        teacher: "Valtolina Stefano",
        teacherLink: "https://www.unimi.it/en/ugov/person/stefano-valtolina",
      },
      {
        id: 7,
        title: "Multimedial Techa Organization and Digitalization",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/multimedial-techa-organization-and-digitalization-0",
        teacher: "Haus Goffredo Maria",
        teacherLink: "https://www.unimi.it/en/ugov/person/goffredo-haus",
      },
      {
        id: 8,
        title: "Natural Interaction",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/natural-interaction",
        teacher: "Boccignone Giuseppe",
        teacherLink: "https://www.unimi.it/en/ugov/person/giuseppe-boccignone",
      },
      {
        id: 9,
        title: "Privacy and Data Protection",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/privacy-and-data-protection",
        teacher: "Samarati Pierangela",
        teacherLink: "https://www.unimi.it/en/ugov/person/pierangela-samarati",
      },
      {
        id: 10,
        title: "Web Algorithmic",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2023/web-algorithmics",
        teacher: "Vigna Sebastiano",
        teacherLink: "https://www.unimi.it/en/ugov/person/sebastiano-vigna",
      },
      {
        id: 11,
        title: "Biometric Systems",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2022/biometric-systems",
        teacher: "Scotti Fabio",
        teacherLink: "https://www.unimi.it/en/ugov/person/fabio-scotti",
      },
      {
        id: 12,
        title: "Advanced Biometrics",
        link:
          "https://www.unimi.it/en/education/degree-programme-courses/2022/advanced-biometrics",
        teacher: "Scotti Fabio",
        teacherLink: "https://www.unimi.it/en/ugov/person/fabio-scotti",
      },
    ],
  },
];
